// About 2026 (page.about-2026) — interactions scoped to .about-2026 (ENG-7781).
// Nav-scroll from the design mockup is omitted on purpose: the header is
// provided by the theme chrome. Two behaviors: scroll-reveal and the
// how-it-works tabs (data emitted from Liquid so image_picker overrides flow).
(function () {
  const root = document.querySelector('.about-2026');
  if (!root) return;

  // ── Scroll reveal ──
  // Faithful port of the design: on intersection, stagger any .vcard
  // descendants (transitionDelay = i * 70ms) then reveal the container.
  // Guard on IntersectionObserver (same as faq-2026.js / contact-2026.js): if
  // it's unavailable the constructor would throw and abort the whole IIFE —
  // taking the tabs down with it — so fall back to revealing everything.
  const reveals = root.querySelectorAll('.reveal');
  if (!('IntersectionObserver' in window)) {
    reveals.forEach((el) => el.classList.add('visible'));
  } else {
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        el.querySelectorAll('.vcard').forEach((card, i) => {
          card.style.transitionDelay = i * 70 + 'ms';
        });
        el.classList.add('visible');
        revealObserver.unobserve(el);
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -40px 0px' });

    reveals.forEach((el) => revealObserver.observe(el));
  }

  // ── How-it-works tabs ──
  (function initTabs() {
    const tabs = Array.from(root.querySelectorAll('.hiw-tab'));
    if (!tabs.length) return;

    const vis = root.querySelector('#hiwVis');
    const head = root.querySelector('#hiwH');
    const body = root.querySelector('#hiwP');
    const note = root.querySelector('#hiwN');

    let data = [];
    const dataEl = root.querySelector('[data-about-hiw]');
    if (dataEl) {
      try { data = JSON.parse(dataEl.textContent); } catch (e) { data = []; }
    }

    function activate(tab, focus) {
      tabs.forEach((t) => {
        const isActive = t === tab;
        t.classList.toggle('active', isActive);
        t.setAttribute('aria-selected', isActive ? 'true' : 'false');
        t.tabIndex = isActive ? 0 : -1;
      });
      // Keep the panel's accessible name in sync with the active tab, so a
      // screen reader announces the current tab's label, not tab 1's.
      const panel = root.querySelector('#hiw-panel');
      if (panel) panel.setAttribute('aria-labelledby', tab.id);
      const d = data[+tab.dataset.i];
      if (d && vis) {
        vis.style.background = d.g;
        // #hiwVis is role="img"; keep its accessible name in sync with the tab.
        if (d.a) vis.setAttribute('aria-label', d.a);
        if (head) head.textContent = d.h;
        if (body) body.textContent = d.p;
        if (note) note.textContent = d.n;
      }
      if (focus) tab.focus();
    }

    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => activate(tab, false));
      tab.addEventListener('keydown', (e) => {
        let next = -1;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (i + 1) % tabs.length;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = tabs.length - 1;
        if (next === -1) return;
        e.preventDefault();
        activate(tabs[next], true);
      });
    });
  })();
})();
